import * as f from '../../../components/BPMTable/BPMInputs'
import {
    TableFieldDescription,
    DataMapper,
    DataTransformer,
    StatusChipComponentCreator,
    DefaultClickStrategy,
    SimpleTableDisplayStrategy,
    DateTimeComponentCreator,
} from '../../../components/BPMTable/TableMapperCreator'
import { checkProcessDuration } from '../../../utils/processControlUtils'
import TableCreatorCreator from '../../../components/BPMTable/TableCreatorFactory/TableCreatorCreator'
import tableCreatorCreatorFactoryCreator from '../../../components/BPMTable/TableCreatorFactory/TableCreatorCreatorFactoryCreator'
import { DirectTableQueryBuilder } from "../../../components/BPMTable/TableQueryBuilder/DirectTableQueryBuilder"
import { QueryVariable } from "../../../components/BPMTable/TableQueryBuilder/AbstractVariableStrategy"

let editMutator

let newMutator

let deleteMutator

const unitQuery = `
    processControlSubProcess(id: $id) {
        id
        taskName
        state
        createdAt
        updatedAt
        message
        duration
    }
`

const SubProcessTableCreatorCreatorQueries = {tableQueryBuilder: new DirectTableQueryBuilder('processControlSubProcesses'), editMutator, newMutator, deleteMutator, unitQuery}

class SubProcessTableCreatorCreator extends TableCreatorCreator {
    constructor(filters) {
        super(filters)
    }

    static getId = () => {
        return "SubProcessTableCreatorCreator"
    }

    getTableCreator = (tableName) => {
        const tableCreator =  this.createTableCreator(
            this.constructor.getId(), 
            tableName, 
            SubProcessTableCreatorCreatorQueries, 
            new DefaultClickStrategy(), 
            new SimpleTableDisplayStrategy());
        tableCreator.setDefaultRowHeight(25);
        tableCreator.setVariables([
            new QueryVariable('processControlId', 'String!')
        ]);

        tableCreator.addDescriptions([
            new TableFieldDescription(
                'taskName',
                new DataMapper("taskName"),
                new f.FilterDescription(new f.NullCreator()),
                {label: 'Task Name'}
            ),
            new TableFieldDescription(
                'state',
                new DataMapper("state"),
                new f.FilterDescription(new f.NullCreator()),
                {label: 'State', componentCreator: new StatusChipComponentCreator()}
            ),
            new TableFieldDescription(
                'createdAt',
                new DataMapper("createdAt"),
                new f.FilterDescription(new f.NullCreator()),
                {label: 'Created At', componentCreator: new DateTimeComponentCreator()}
            ),
            new TableFieldDescription(
                'startedAt',
                new DataMapper("startedAt"),
                new f.FilterDescription(new f.NullCreator()),
                {label: 'Started At', componentCreator: new DateTimeComponentCreator()}
            ),
            new TableFieldDescription(
                'duration',
                new DataMapper("duration", "createdAt", "updatedAt", "state"),
                new f.FilterDescription(new f.NullCreator()),
                {label: 'Duration', transform: new DataTransformer(({duration, createdAt, updatedAt, state}) => checkProcessDuration(duration, createdAt, updatedAt, state))}
            ),
            new TableFieldDescription(
                'message',
                new DataMapper("message"),
                new f.FilterDescription(new f.NullCreator()),
                {label: 'Message'}
            ),
        ])
        
        return tableCreator;
    }
}

tableCreatorCreatorFactoryCreator.addTableCreatorCreator(SubProcessTableCreatorCreator)

export default SubProcessTableCreatorCreator
